import React from 'react';
import { ILocationSummary } from 'gen/ApiClient';

interface IContext {
	location: ILocationSummary | undefined;
}

export const CurrentLocationContext = React.createContext<IContext>(undefined as any);
